const dsRuns = (($) => {

    const modal_delivery = 'div#green-modal[data-type="delivery"]',
        modal_postcode = modal_delivery + ' div#enter-postcode',
        modal_runs = modal_delivery + ' div#preferred-delivery-day',
        run_list = modal_runs + ' div#run_list',
        modal_select = modal_delivery + ' select',
        modal_input = modal_delivery + ' input',
        modal_text = `${modal_delivery} p.green-modal`,
        timeslot = 'select#time_slot',
        timeslot_text = 'div#delivery_time_text',
        ts_error = 'p#ts_error',
        run_data = 'input#run_data',
        run_select = 'input.run_select',
        guaranteed = 'p#box-guaranteed',
        cal_checkmark = 'span#checkmark-calendar',
        run_date_text = 'p#my-box-run-date';
    let fresh;

    function getSuburbs(request) {
        $.ajax({
            type: 'GET',
            url: dsUtilities.urlAddress() + '/postcode',
            dataType: 'json',
            data: { request: request },
            success: function (data) {
                $.ajax({
                    url: dsUtilities.urlModuleOrder() + '/asked',
                    type: 'POST'
                });
                if (data.localities.locality instanceof Array) {
                    populateSuburbs(data.localities.locality);
                } else {
                    populateSuburbs(data.localities);
                }
            }
        });
    }

    function populateSuburbs(suburbs) {
        if (typeof suburbs === 'object') {
            $(modal_select).empty().append($('<option>', {value: '', text: 'Select a Suburb'}));
            if (suburbs instanceof Array) {
                suburbs.forEach(function (suburb) {
                    const opt = suburb.location + ', ' + suburb.postcode;
                    $(modal_select).append($('<option>', {value: opt, text: opt}));
                });
            } else {
                const opt = suburbs.locality.location + ', ' + suburbs.locality.postcode;
                $(modal_select).append($('<option>', {value: opt, text: opt}));
            }
            $(modal_input).addClass('hide');
            $(modal_select).removeClass('hide');
            if ("showPicker" in HTMLInputElement.prototype) {
                document.getElementById('delivery-modal-select').showPicker();
            }
        }
    }

    function selectSuburb(suburb) {
        $.ajax({
            type: 'POST',
            url: 'index.php?route=common/header/set_saved_suburb',
            dataType: 'json',
            data: { suburb: suburb },
            success: function (response) {
                if (response.success) {
                    suburbSelected(suburb, response.message);
                    doorstep.fresh = response.fresh;
                    doorstep.fresh_order = response.fresh;
                    doorstep.weight = response.weight;
                    if (response.weight) {
                        $(run_date_text).removeClass('hide').html('Delivery date: <strong>' + moment(response.date, 'YYYY-MM-DD').format('ddd, MMM D') +  '</strong>');
                    }
                }
            }
        });
    }

    function suburbSelected(suburb, message) {
        $(modal_select).empty().addClass('hide');
        $(modal_input).removeClass('hide');
        $(run_select).val(suburb);
        $('div#my-box-availability').addClass('hide');
        $('div#my_box_suburb').removeClass('hide');
        if (message.length > 0) {
            $(guaranteed).removeClass('hide').html(message);
        } else {
            $(guaranteed).addClass('hide').html('');
        }
        const aSuburb = suburb.split(','),
            sub = aSuburb[0].trim(),
            postcode = aSuburb[1].trim();
        if (postcode != doorstep.saved_run_postcode) {
            clearRun(sub, postcode);
        }
        doorstep.saved_run_city = sub;
        doorstep.saved_run_postcode = postcode;
        $('div#postcode-banner').addClass('hide');
        openRunSelect();
    }
    function clearRun(suburb, postcode) {
        doorstep.address_id = '';
        doorstep.saved_run = '';
        doorstep.saved_run_date = '';
        doorstep.saved_run_city = '';
        doorstep.saved_run_city = '';
        doorstep.saved_time_slot = '';
        doorstep.saved_time_start = '';
        doorstep.saved_time_end = '';
        $.ajax({
            type: 'POST',
            url: dsUtilities.urlModuleOrder() + '/clear_run',
            dataType: 'json',
            data: { suburb: suburb, postcode: postcode },
        });
    }

    function openWeightDate(el) {
        var today = new Date();
        $(el).flatpickr({
            dateFormat : 'Y-m-d',
            locale  : { 'firstDayOfWeek' : 1 },
            minDate : today.setDate(today.getDate() + 1),
            disable : [
                function(date) {
                    return date.getDay() === 0;
                }
            ],
            onChange : function (date, dateStr) {
                $(run_date_text).html('Shipping date: ' + moment(dateStr).format('ddd, MMM D'));
                doorstep.saved_run_date = dateStr;
                setRunDate(dateStr)
            }
        }).open();
    }

    function setRunDate(date) {
        $.ajax({
            type: 'POST',
            url: dsUtilities.urlModuleOrder() + '/set_run_date',
            dataType: 'json',
            data: { date: date }
        });
    }

    function isPostcodeSelected() {
        return doorstep.saved_run_city.length > 0 && doorstep.saved_run_postcode.length > 0;
    }

    function findRuns() {
        if (isPostcodeSelected()) {
            getRuns('runs').done(function(response) {
                doorstep.weight = response.type === 'weight';
                if (response.type === 'runs') {
                    if (response.diff !== '') {
                        $(guaranteed).removeClass('hide').html(response.diff);
                    }
                    writeRuns('runs', run_list, response)
                }
                if (response.type === 'weight' || response.type === 'undeliverable') {
                    writeWeight('runs', run_list, response.message);
                }
            });
        }
    }

    function getRuns(source, suburb = doorstep.saved_run_city, postcode = doorstep.saved_run_postcode) {
        return  $.ajax({
            type: 'POST',
            url: dsUtilities.urlModuleOrder() + '/find_runs',
            dataType: 'json',
            data: { suburb: suburb, postcode: postcode, source: source }
        });
    }

    function getRunDays(runs) {
        let days = [],
            BreakException = {};
        try {
            runs.forEach(function(run) {
                if (days.length === 7) {
                    throw BreakException;
                }
                if (!days.includes(run.day)) {
                    days.push(run.day)
                }
            });
        } catch (e) {}
        return days;
    }

    function writeWeight(source, el, message) {
        $(`${timeslot}, ${timeslot_text}`).hide();
        if (source === 'runs') {
            $(modal_delivery + ' p.green-modal').html('').append(message);
        }
        if (source === 'checkout') {
            $(el).html(message);
        }
    }

    function writeRuns(source, el, data) {
        let runs = data.runs !== undefined ? data.runs : {},
            html = '',
            enable = [],
            df = 'YYYY-MM-DD',
            el_item = el + ' ' + (source === 'runs' ? 'button' : 'input[type="radio"]'),
            alcohol = dsCart.hasAlcohol(),
            the_run = getRunFromDate(data),
            is_cal_date = false,
            filter_runs = [];
        const max = runs[0].date !== undefined && moment().format(df) === moment(runs[0].date).format(df) ? 6 : 5;
        $(`${timeslot}, ${timeslot_text}`).show();
        if (source === 'runs') {
            $(modal_text).html('Select your preferred delivery day');
        }
        const cal_run_date = runs[max - 1] !== undefined ? moment(runs[max - 1].date) : '';
        runs.forEach(function (run, i) {
            if (i < max) {
                if (source === 'runs') {
                    if (shouldDisplayRun(run, alcohol)) {
                        const display = i === max - 1 ? '<p>Show calendar</p><img src="/dist/images/calendar_white.svg" width="20"/>' : '<p>' + run.display + '</p>';
                        html += `<button class="${run.display.startsWith('Today') ? 'orange' : 'green'} delivery-btn" data-id="${run.run_id}" data-date="${run.date}" data-method="${run.method}" data-lookup="${run.run_lookup}">${display}</button>`;
                    }
                } else {
                    let display = run.display,
                        run_date = '';
                    const checked = runFound(run),
                        last = i === max - 1;
                    is_cal_date = isCalDate(last, cal_run_date);
                    if (last) {
                        run_date = is_cal_date && the_run.run_id !== undefined ? '<br>' + moment(the_run.date).format('dddd, D MMM') : '';
                        display = `<div id="show_calendar">Show calendar <img src="/dist/images/calendar_black.svg" width="20"/><span id="calendar_date">${run_date}</span></div>`
                    }
                    if (!the_run.ts_show) {
                        timeslotsHide();
                    }
                    if (shouldDisplayRun(run, alcohol)) {
                        html += `<label class="options-list-item">
<input${checked ? ' checked' : ''} type="radio" name="run" data-id="${run.run_id}" data-date="${run.date}" data-method="${run.method}" data-lookup="${run.run_lookup}" data-minimum="${run.minimum}" data-ts_show="${run.ts_show}" data-timeslots="${Object.entries(run.time_slots)}">
<span class="checkmark${is_cal_date && the_run.run_id !== undefined ? ' flatpickr_checkmark' : ''}"${last ? 'id="checkmark-calendar"' : ''}></span><span>${display}</span></label>`;
                        if (checked) {
                            run.id = run.run_id;
                            run.lookup = run.run_lookup;
                            if (source === 'checkout') {
                                dsCheckout.setRunData(run);
                            }
                        }
                        if (source === 'checkout' && is_cal_date) {
                            dsCheckout.setRunData({ 'id' : the_run.run_id ?? '', 'date' : the_run.date ?? '', 'lookup' : the_run.run_lookup ?? '' });
                        }
                    } else {
                        filter_runs.push(run.date);
                    }
                }
            }
            enable.push(moment(run.date).format(df));
        });
        $(el).html('').append(html);
        $(el_item).not(':last').on('click', function () {
            $(cal_checkmark).removeClass('flatpickr_checkmark');
            selectRun(source, {
                id         : $(this).attr('data-id'),
                date       : $(this).attr('data-date'),
                method     : $(this).attr('data-method'),
                lookup     : $(this).attr('data-lookup'),
                minimum    : $(this).attr('data-minimum'),
                time_slots : $(this).attr('data-timeslots'),
                ts_show    : $(this).attr('data-ts_show')
            });
            if (source === 'checkout') {
                dsCheckout.setRunData({ 'id': parseInt($(this).attr('data-id')), 'date': $(this).attr('data-date'), 'lookup': $(this).attr('data-lookup') });
            }
        });
        if (!$(el_item + ':checked').length && !is_cal_date) {
            $(run_data).attr('data-id', '').attr('data-date', '').attr('data-lookup', '');
        }
        if (source === 'checkout' && the_run.run_id !== undefined) {
            writeTimeSlots(Object.entries(the_run.time_slots), the_run.ts_show);
        }
        runs = runs.filter(function(run){
            return !filter_runs.includes(run.date);
        });
        showCalendar(source, el_item, runs, enable);
    }

    function isCalDate(last, date) {
        return last && doorstep.saved_run_date.length > 0 && moment(doorstep.saved_run_date).isSameOrAfter(date);
    }

    function getRunFromDate(data) {
        const key = data.dates.findIndex(x => x === doorstep.saved_run_date);
        return key === -1 ? {} : data.runs[key];
    }

    function shouldDisplayRun(run, alcohol) {
        return run.display.startsWith('Today') && !alcohol || !run.display.startsWith('Today')
    }

    function runFound(run) {
        return (doorstep.saved_run.length > 0 && doorstep.saved_run.charAt(0) === 'Z' && doorstep.saved_run === run.run_id) || (doorstep.saved_run === parseInt(run.run_id));
    }

    function showCalendar(source, el, runs, enable) {
        $(el + ':last').flatpickr({
            dateFormat : 'Y-m-d',
            locale : { 'firstDayOfWeek' : 1 },
            onChange : function (date, dateStr) {
                runs.every(function(run) {
                    if (run.date === dateStr) {
                        selectRun(source, {
                            id         : run.run_id,
                            date       : run.date,
                            method     : run.method,
                            lookup     : run.run_lookup,
                            minimum    : run.minimum,
                            time_slots : run.time_slots !== undefined ? Object.entries(run.time_slots) : [],
                            ts_show    : run.ts_show
                        });
                        if (source === 'checkout') {
                            $(el).prop('checked', false);
                            checkCalendarDate(run)
                            dsCheckout.setRunData({ 'id': parseInt(run.run_id), 'date': run.date, 'lookup': run.run_lookup });
                        }
                        return false;
                    }
                    return true;
                });
            },
            enable: enable
        });
    }

    function checkCalendarDate(run) {
        $(cal_checkmark).addClass('flatpickr_checkmark');
        $('span#calendar_date').html('<br>' + moment(run.date).format('dddd, D MMM') + ' (' + run.time_range + ', min $' + run.minimum.replace('.00', '') + ')');
    }

    function selectRun(source, data) {
        data.suburb = doorstep.saved_run_city;
        data.postcode = doorstep.saved_run_postcode;
        if (source === 'checkout') {
            $('span#calendar_date').html('');
            writeTimeSlots(data.time_slots, data.ts_show);
        }
        if (source === 'runs') {
            $.ajax({
                type: 'POST',
                url: dsUtilities.urlModuleOrder() + '/save_run',
                dataType: 'json',
                data: data,
                success: function (response) {
                    if (response.success) {
                        doorstep.saved_run = data.id;
                        doorstep.saved_run_date = data.date;
                    }
                    $(run_date_text).removeClass('hide').html('Delivery date: <strong>' + moment(data.date, 'YYYY-MM-DD').format('ddd, MMM D') +  '</strong>');
                    closeModal();
                    if (source === 'runs' && doorstep.add_to_cart.product !==  undefined && !doorstep.add_to_cart.product.mixed && !doorstep.add_to_cart.product.bundle) {
                        location.reload();
                    }
                }
            });
        }
    }

    function writeTimeSlots(data, show = 1) {
        let time_slots = [];
        $(ts_error).addClass('hide');
        $(`${timeslot}, ${timeslot_text}`).removeClass('hide');
        $(`${timeslot} option`).remove();
        if (parseInt(show) === 1) {
            if (!Array.isArray(data)) {
                const arr = data.split(',');
                arr.forEach(function (v, i) {
                    if (parseInt(i) % 2) {
                        time_slots.push([arr[i - 1], v])
                    }
                });
                data = time_slots;
            }
            const ts_init = data.length > 0 ? 'Optional: Choose a Delivery Time Slot' : 'No Time Slots available';
            $(timeslot).append($('<option />').text(ts_init).val(ts_init));
            data.forEach(function (ts) {
                const id = ts[0];
                if (id.length > 0) {
                    $(timeslot).append($('<option />').val(id).text(ts[1]).prop('selected', doorstep.saved_time_slot === parseInt(id)));
                }
            });
        } else {
            timeslotsHide();
        }
        if (typeof dsCheckout !== 'undefined') {
            dsCheckout.setHeight(3);
        }
    }

    function timeslotsHide() {
        $(`${timeslot}, ${timeslot_text}`).addClass('hide');
        $(ts_error).removeClass('hide');
    }

    function openModal(select_suburb = false) {
        const allow = ![4,20].includes(doorstep.editstatus),
            pc_input = 'input#delivery-postcode';
        $(`${modal_delivery}, ${modal_postcode}, ${pc_input}`).removeClass('hide');
        if (allow) {
            fresh = doorstep.fresh;
            $(pc_input).removeClass('hide');
            doorstep.run_asked = true;
            $.ajax({url: dsUtilities.urlModuleOrder() + '/asked', type: 'POST'});
            $(modal_input).focus();
            $(modal_text).html('Enter your post code or suburb for real-time product availability and same-day delivery times');
            if (select_suburb && doorstep.saved_run_postcode > 0 && doorstep.saved_run_city.length > 0) {
                selectSuburb(`${doorstep.saved_run_city}, ${doorstep.saved_run_postcode}`);
            }
        } else {
            $(pc_input).addClass('hide');
            $(modal_text).html('Your order is in PACKING status so you are unable to change the delivery address or delivery date of this order.');
        }
    }

    function closeModal() {
        $(run_list).html('');
        $(modal_delivery).addClass('hide');
        $(modal_postcode).removeClass('hide');
        $(modal_runs).css('display', 'none');
        $(modal_input).val('').removeClass('hide');
        $(modal_select).empty().addClass('hide');
        if (dsCart.cartObjectIsValid()) {
            dsCart.addToCartProcess(false);
        } else {
            if (fresh !== doorstep.fresh && doorstep.page_type === 'product' && ![4,20].includes(doorstep.editstatus)) {
                location.reload();
            }
        }
    }

    function openRunSelect() {
        $(modal_delivery).removeClass('hide');
        $(modal_postcode).addClass('hide');
        $(modal_runs).css('display', 'flex');
        findRuns();
    }

    $(document).ready(function () {

        $('#green-modal input').on('keydown', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        }).on('keyup', function () {
            const request = $(this).val();
            if (request.length > 3) {
                getSuburbs(request);
            }
        });

        $('#green-modal select').on('change', function () {
            const suburb = $(this).val();
            if (suburb.length > 0) {
                selectSuburb(suburb);
            }
        });

        $('#my-box-load').on('click', run_select + ', button#cart_availability', function () {
            openModal();
        }).focusout(function () {
            if (isPostcodeSelected()) {
                $(this).val(doorstep.saved_run_city + ', ' + doorstep.saved_run_postcode);
            }
        });

        $('img#enter-postcode_close').on('click', function () {
            closeModal();
        });

    });

    return {
        openModal      : openModal,
        getRuns        : getRuns,
        selectRun      : selectRun,
        writeRuns      : writeRuns,
        writeWeight    : writeWeight,
        getRunDays     : getRunDays,
        writeTimeSlots : writeTimeSlots,
        clearRun       : clearRun,
        openWeightDate : openWeightDate
    }
})(jQuery);